<script>
    import ImageHeader from '@/components/page-file-edit/images/ImageHeader.vue';
    import ImageHeaderDisable from '@/components/page-file-edit/images/ImageHeaderDisable.vue';
    import ImageFilter from '@/components/page-file-edit/images/ImageFilter.vue';
    import ImagePreview from '@/components/page-file-edit/images/ImagePreview.vue';
    import ImagePreviewDisable from '@/components/page-file-edit/images/ImagePreviewDisable.vue';
    import ImageTag from '@/components/page-file-edit/images/ImageTag.vue';
    import ImageAdditionalTag from '@/components/page-file-edit/images/ImageAdditionalTag.vue';
    import ImageAdditionalStatus from '@/components/page-file-edit/images/ImageAdditionalStatus.vue';
    import DisputeBar from '@/components/page-file-edit/images/DisputeBar.vue';


    export default {
        data() {
            return {
                isShowAdditionalSetting: false,
                // A disputed row starts folded to its bar; the full editor is a click away.
                isExpanded: false,
            }
        },
        props: {
            file: Object,
            functionUpdatePage: Function,
        },
        components: {
            ImageHeader: ImageHeader,
            ImageHeaderDisable: ImageHeaderDisable,
            ImageFilter: ImageFilter,
            ImagePreview: ImagePreview,
            ImagePreviewDisable: ImagePreviewDisable,
            ImageTag: ImageTag,
            ImageAdditionalTag: ImageAdditionalTag,
            ImageAdditionalStatus: ImageAdditionalStatus,
            DisputeBar: DisputeBar,
        },
        computed: {
            // The bar and the folding belong to the GUP uploads page only; on
            // /file-edit a disputed file is an ordinary file.
            hasDispute() {
                return this.$store.getters.CURRENT_DISPUTED === true
                    && this.file['modelAssetTypeId'] != null;
            },
            showBody() { return this.hasDispute === false || this.isExpanded === true },
        },
        watch: {
            // Any save that clears the dispute (bar buttons, header Save, Save All)
            // takes the row out of the disputes list.
            async hasDispute(now, before) {
                if (before === true && now === false && this.$store.getters.CURRENT_DISPUTED === true) {
                    this.$store.commit('IMAGE_DELETE_BY_ID', this.file.id);
                    if (this.functionUpdatePage != null) await this.functionUpdatePage();
                }
            }
        },
        methods: {
            async toggleAdditionalSetting() {
                this.isShowAdditionalSetting = !this.isShowAdditionalSetting;
            },
            async toggleExpanded() {
                this.isExpanded = !this.isExpanded;
            }
        }
    }
</script>


<template>
    <div class="image_container">
        <DisputeBar
            v-if="hasDispute === true"
            :file = "file"
            :expanded = "isExpanded"
            :toggleExpanded = "toggleExpanded"
            :functionUpdatePage = "functionUpdatePage"
        />
        <template v-if="showBody === true">
        <ImageHeader 
            v-if="file['isActive'] === true"
            :file = "file"
            :additionalSetting = "isShowAdditionalSetting"
            :toggleAdditionalSetting = "toggleAdditionalSetting"
        />
        <ImageHeaderDisable 
            v-else
            :file = "file"
            :functionUpdatePage = "functionUpdatePage"
        />
        <hr>
        <div 
            class="image_middle"
            v-if="file['isActive'] === true"    
        >
            <ImagePreview 
                :file = "file"
            />
            <ImageFilter :file = "file"/>
        </div>
        <div
            class="image_middle"
            v-else
        >
            <ImagePreviewDisable 
                :file = "file"
            />
            <div class="image_disable_text">
                <p>
                    The image was deleted by the 'Spider' program.
                </p>
                <p>
                    This means that the image is not physically 
                    present on the disk.
                </p>
                <p>
                    If you think that the image was deleted by 
                    mistake, then click the 'Recovery' button and 
                    manually restore the file to disk.
                </p>
                <p>
                    If you think that the image needs to be 
                    completely deleted from the database, then 
                    click 'Delete'. Attention! this operation 
                    completely deletes the file and it cannot be restored.
                </p>
            </div>
        </div>
        <div 
            class="image_footer"
            v-if="file['isActive'] === true"
        >
            <hr>
            <ImageTag :file = "file"/>
            <hr>
            <ImageAdditionalTag :file = "file"/>
            <hr v-if="isShowAdditionalSetting === true">
            <ImageAdditionalStatus 
                v-if="isShowAdditionalSetting === true"
                :file = "file"
            />
        </div>
        </template>
    </div>    
</template>


<style scoped>
    hr {
        width: 98%;
        border: 1px solid var(--header-separator);
    }

    .image_container {
        background-color: var(--header);
        color: var(--header-text);
        
        /* border: 1px solid #000000; */
        border-radius: 5px;

        width: 100%;

        margin-top: 20px;
        margin-bottom: 5px;
    }
    .image_middle {
        display: flex;
    }
    .image_footer {
        display: flex;
        flex-direction: column;
    }

    .image_disable_text {
        flex: 1 1 50%;
        border-left: 2px solid #30333a;
        padding: 10px;
        display: flex;
        flex-direction: column;
    }
</style>